<header class="row  shadow mx-1 mb-3 rounded">
    <div class="col ">
        <img [src]="logoImage" class="img-fluid" alt="NC header logo picture"
      height="100" width="275"/>
    </div>
    <div class="col-7 text-center">
        <h1 class=" fw-bold">Online Application for NC HIPP</h1>
        <h1 class=" fw-bold">North Carolina Health Insurance Premium Payment Program</h1>
        <strong>Fill out this form. Then click Submit to send it to us.</strong>

        <p>If you prefer to download a North Carolina HIPP Program Application
            <a style="color: #0c69f2;" lang="en" href="javascript:void(0)" (click)="openPaperApplication()">click here</a>
        </p>
    </div>
    <div class="col-2 "></div>
</header>
<br/>


<main>
    <app-ncform  [preference]="preference" [errorMessageIntialData]="errorMessageIntialData"
    [email]="email" [address]="address" [emailTo]="emailTo" [faxNo]="faxNo" [tollfreeNo]="tollfreeNo">
    </app-ncform>
</main>
<footer class="text-center " style="background-color: #f1f1f1;">
    <div class="bg-light text-center ">
        <br />
        <p>Please call us at {{tollfreeNo}} or send an email to
            <a target="_blank" [href]="emailTo" alt="Email" title="email" lang="en"
                style="color: #0c69f2;">{{email}}</a>
            if you experience problems with this form.
        </p>
    </div>

    <div class="text-center p-3 bg-secondary bg-opacity-50 bg-gradient">
        <p class="text-dark">HMS, Inc. All Rights Reserved</p>
    </div>
</footer>
